/**
 * kiểu hiển thị content cột Action GridEditor
 * ICON - TEXT
 */
export default {
  Text: 0,
  Icon: 1,
};
